module.exports = __webpack_public_path__ + "31c224193ce298fbdaf2fc7e5bdf5e09.svg";